import {useQuery} from '@tanstack/react-query'

import {useAuth} from '@fitro/customer-host/auth'
import {partnerStaffAccessKeys} from '../lib/queryKeys'
import {resolvePartnerSlug} from '../lib/partner-slug'
import {apiFetch} from '@fitro/customer-host/api'

export type StaffAccessResponse = {
    member: boolean
    status?: string | null
    role?: string | null
}

const STAFF_ACCESS_STALE_MS = 30_000

const staffAccessPath = (slug: string) =>
    `/api/public/partners/${encodeURIComponent(slug)}/staff/me`

const fetchStaffAccess = (slug: string): Promise<StaffAccessResponse> =>
    apiFetch<StaffAccessResponse>(staffAccessPath(slug), {method: 'GET'})

type PartnerStaffAccessOptions = {
    enabled?: boolean
}

export const usePartnerStaffAccess = (options: PartnerStaffAccessOptions = {}) => {
    const {isLoaded, isSignedIn, userId} = useAuth()
    const slug = resolvePartnerSlug()
    const enabled = options.enabled !== false && Boolean(isLoaded && isSignedIn && userId && slug)
    const query = useQuery({
        queryKey:
            slug && userId
                ? partnerStaffAccessKeys.detail(slug, userId)
                : partnerStaffAccessKeys.detail('_', '_'),
        queryFn: () => fetchStaffAccess(slug as string),
        enabled,
        staleTime: STAFF_ACCESS_STALE_MS,
        gcTime: 5 * 60_000,
    })

    return {
        data: enabled ? query.data ?? null : null,
        isLoading: enabled ? query.isLoading : false,
        error: enabled ? query.error : null,
        slug,
    }
}
